import React from 'react';

import FrameFilters from './filters/FrameFilters';
import FrameOutput from './output/FrameOutput';
import { PROMPT_TYPE } from '../../../constants';
import ImagesGeneratingStatusController from '../generating-status-controller/ImagesGeneratingStatusController';

import scss from '../../Id8.module.scss';

function FrameTab() {
  return (
    <div className={scss.outputWrapper}>
      <FrameFilters />
      <FrameOutput />

      <ImagesGeneratingStatusController promptType={PROMPT_TYPE.IDEA} generationLabel='imagesGenerationInProgress' />
    </div>
  );
}

export default FrameTab;
